import React from "react";
import Box from "ui-box";
import { withTheme } from "styled-components/macro";

const Element = ({
  color,
  backgroundColor,
  cursor,
  onClick,
  theme,
  ...props
}) => {
  return (
    <Box
      color={color ? theme[`@${color}`] || color : "inherit"}
      backgroundColor={
        backgroundColor
          ? theme[`@${backgroundColor}`] || backgroundColor
          : "inherit"
      }
      cursor={cursor || onClick ? "pointer" : "inherit"}
      {...props}
    />
  );
};

export default withTheme(Element);
